/* eslint-disable no-console */
import mqtt, { mqttSub, mqttUnsub } from 'utils/mqtt'
import router from 'router'
import Debug from 'debug'
import { UPDATE_USER_ASSET } from 'store/mutation-types'
import Notification from 'com/Notification'
import { getAlertTypeList } from 'mod/StockPriceAlerts/util'
import { getOrderStatusNotifyMsg } from 'utils/getOrderNotifyMsg'
import { MSG_TYPE } from 'const/common'

export const weight = 100
const $debug = Debug('app:mqtt')
export default function(store) {
  // 账户信息发生变化时，重新连接 mqtt
  store.watch(
    (state, getters) => `${getters.token}|${getters.uuid}|${getters.isVirtual}`,
    str => {
      const [token, uuid, isVirtual] = str.split('|')
      if (token && uuid && isVirtual === 'false') {
        store.dispatch('connectMqtt')
      } else {
        store.dispatch('disconnectMqtt')
      }
    },
    { immediate: true }
  )
  store.watch(
    (state, getters) => {
      return getters.mqttConnected && getters.isDeposited && !getters.isVirtual
    },
    bool => {
      if (bool) {
        mqttSub('userAsset', {
          name: 'asset',
          symbol: '+',
          type: 'detail'
        })
      } else {
        mqttUnsub('userAsset', {
          name: 'asset',
          symbol: '+',
          type: 'detail'
        })
      }
    }
  )

  // 订阅订单和股价提醒
  store.watch(
    (state, getters) => getters.mqttConnected,
    connected => {
      if (connected) {
        mqttSub('priceAlert', {
          name: 'alert'
        })
        mqttSub('orderStatus', {
          name: 'order',
          symbol: '+',
          type: 'detail'
        })
      }
    }
  )

  store.watch(
    (state, getters) => {
      return getters.mqttConnected
    },
    connected => {
      if (connected) {
        if (mqtt.on) {
          // 资产消息
          mqtt.on('update.asset', assetUpdateHandler)
          // 股价提醒消息
          mqtt.on('update.alert', alertUpdateHandler)
          // 订单消息
          mqtt.on('update.order', orderUpdateHandler)
        }
      } else {
        if (mqtt.off) {
          mqtt.off('update.asset', assetUpdateHandler)
          mqtt.off('update.alert', alertUpdateHandler)
          mqtt.off('update.order', orderUpdateHandler)
        }
      }
    }
  )
  // 处理资产消息
  function assetUpdateHandler({ data }) {
    $debug('on receive asset:', data)
    const result = Object.assign({}, store.state.asset, data)
    store.commit(UPDATE_USER_ASSET, result)
  }
  // 处理股价提醒消息
  function alertUpdateHandler({ data }) {
    $debug('on receive alert: ', data)
    const list = getAlertTypeList(data)
    const target = list.find(d => d.val === data.alertType)
    if (target) {
      const name =
        store.getters.language === 'zh-cn' ? data.nameCN : data.nameEN
      const title = data.symbol + '(' + name + ')'
      const content = `${target.text} ${data.condition.threshold}${target.unit}`
      Notification.open({
        useNative: true,
        silent: false,
        title,
        content,
        onClick: function() {
          store.dispatch('updateMsgMark', MSG_TYPE.PRICE)
          router.push({ name: 'chart', params: { symbol: data.symbol } })
        }
      })
    }
  }
  // 处理订单消息
  function orderUpdateHandler({ data }) {
    $debug('on receive order: ', data)
    if (store.getters.latestOrderStatus === data.timestamp) return
    store.dispatch('orderStatusChange', data.timestamp)
    const orderData = store.getters.isIb ? data : data.data
    const notice = getOrderStatusNotifyMsg(orderData, store.getters.isIb)
    if (notice) {
      Notification.open(notice)
    }
  }
}
